import dayjs from 'dayjs';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatIsoDate(iso: string): string {
  return dayjs(iso).format('MM/DD/YYYY');
}

export function formatPhoneUS(input: string): string {
  const parsed = parsePhoneNumberFromString(input, 'US');
  return parsed?.isPossible() ? parsed.formatNational() : input;
}
